const mutations = {
  showLeftMenu(state, status) {
    state.showLeftMenu = status
  },
  setMenus(state, menus) {
    state.menus = menus
  },
  setRules(state, rules) {
    state.rules = rules
  },
  setUsers(state, users) {
    state.users = users
  },
  setUserGroups(state, userGroups) {
    state.userGroups = userGroups
  },
  setOrganizes(state, organizes) {
    state.organizes = organizes
  },
  updateMenusList(state, data) {
    state.menusList = data.menusList
    state.menusThreeList = data.menusThreeList
  },
  setDocumentTitle(state, title) {   // 设置系统标题
    state.documentTitle = title
  },
  setMenusUpdate(state, menusUpdate) {
    state.menusUpdate = menusUpdate
  },
  setMessageUnRead(state, isUnRead) {
    state.isUnRead = isUnRead
  },
  setIsSetLog(state, isSetLog) {
    state.isSetLog = true
  },
  openImportDialog(state, isImportDialogUpdate) {
    state.isImportDialogUpdate = isImportDialogUpdate
  },
  closeImportDialog(state, isImportDialogClose) {
    state.isImportDialogClose = isImportDialogClose
  },
  setFailIds(state, obj) {
    if (obj) {
      state.contentFailIds[obj.key] = obj.ids
    }
  },
  removeFailIds(state, key) {
    delete state.contentFailIds[key]
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js